import { configureStore as rtkConfigureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';

import rootReducer from '../reducers/rootReducer';
import { router } from '../Routes';

export function configureStore(initialState?: unknown) {
  const sagaMiddleware = createSagaMiddleware();
  sagaMiddleware.setContext({
    router,
  });

  const store = rtkConfigureStore({
    reducer: rootReducer,
    preloadedState: initialState,
    middleware: getDefault =>
      getDefault({
        serializableCheck: false,
        immutableCheck: { ignoredPaths: ['arcgisLayerData'] },
      }).concat(sagaMiddleware),
  });

  if (import.meta.hot) {
    import.meta.hot.accept('../reducers/rootReducer', async () => {
      const { default: nextReducer } = await import('../reducers/rootReducer');
      store.replaceReducer(nextReducer);
    });
  }

  return Object.assign(store, { runSaga: sagaMiddleware.run });
}
